import type { Signal } from '@angular/core';
import type { ContactResource } from '@wizbii/utils/models';

import { InjectionToken } from '@angular/core';

export const ContactDataService = new InjectionToken<ContactDataServiceModel>('ContactDataService');

export interface ContactDataServiceModel {
  contactFormData: Signal<ContactResource>;
}
